import { Component } from 'react';
import { withRouter, Route, Switch } from 'react-router-dom';
import { Grid } from '@material-ui/core';

import InstagramFeed from './InstagramFeed';
import YoutubeFeed from './YoutubeFeed';
import FacebookFeed from './FacebookFeed';
import TwitterFeed from './TwitterFeed';

class Feed extends Component {
  render() {
    return (
      <Grid container spacing={3} style={{ marginTop: 0 }}>
        <Grid item md={12}>
          <Switch>
            <Route exact path={`${this.props.match.url}/youtube`}>
              <YoutubeFeed campaignId={this.props.match.params.campaignId} />
            </Route>
            <Route exact path={`${this.props.match.path}/instagram`}>
              <InstagramFeed campaignId={this.props.match.params.campaignId} />
            </Route>
            <Route exact path={`${this.props.match.url}/facebook`}>
              <FacebookFeed campaignId={this.props.match.params.campaignId} />
            </Route>
            <Route exact path={`${this.props.match.url}/twitter`}>
              <TwitterFeed campaignId={this.props.match.params.campaignId} />
            </Route>
          </Switch>
        </Grid>
      </Grid>
    );
  }
}

export default withRouter(Feed);
